module.exports = __webpack_public_path__ + "img/enemy_1.2baf6c2e.png";